<div class="color-picker-wrap" [ngClass]="{ 'tool-area-content': isDefault }">
  <div class="color-picker" [ngClass]="{ disabled: isDisabled }">
    <a
      (click)="pickColor()"
      [ngStyle]="{ background: currentColor }"
      [ngClass]="{ 'color-picker-button': isDefault, 'color-picker-simlebutton': isSimple }"
      class="color-picker-button"
    >
    </a>
    <ng-container *ngIf="showPicker || isPopup">
      <div class="color-picker-dropdown">
        <div class="color-picker-title">{{ 'Basic Colors' | translate }}</div>
        <ul class="color-picker-list">
          <li
            class="color-picker-item"
            (click)="onBasicColorClick(item)"
            *ngFor="let item of colors"
            [ngStyle]="{ background: item }"
            [ngClass]="{ 'non-color': item === 'none', active: item === currentColor }"
          ></li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
